import React, { useEffect, useState } from 'react';
import Menu from '../../../components/sturtural/Menu';
import { BASE_API } from '../../../api/Globals';
import { helpHttp } from '../../../helpers/helpHttp';
import Loader from '../../../components/sturtural/Loader';
import MessageDetail from '../../../components/sturtural/MessageDetail';
import { Button } from 'primereact/button';

const Record = () => {

    const [db, setDb] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    
    let url = `${BASE_API}demand/inreview`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then(res => {
            if(!res.err) {
                setDb(res.demand);
                setError(null);
            } else {
                setDb(null);
                setError(res);
            }
            setLoading(false);
        });
    },[url]);

    const thead = [
        '#',
        'NOMBRE',
        'VALIDADOR',
        'FECHA ASIGNACIÓN',
        'INSTITUCIÓN EDUCATIVA',
        'TÍTULO',
        'CORREO ELECTRÓNICO',
        'TELÉFONO',
        '...'
    ]

    return (
        <>
            <Menu link='historial' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h5>Historial de asignaciones</h5>
                        <p>De la siguiente lista de solicitudes en espera, seleccione una para darle seguimiento.</p>
                        {loading && <Loader />}
                        {error && <MessageDetail color="error" mensaje={`Error ${error.status}: ${error.statusText}`} />}
                        {db ? (
                            <table className="table table-bordered table-striped table-hover">
                                <thead>
                                    <tr>
                                        {thead.map((el, index) =>
                                            <th scope="col" key={`head-${index}`}>{el}</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {db.map((el, index) => 
                                        <tr key={index}>
                                            <th scope="row">{++index}</th>
                                            <td>{el.nombre} {el.apellido1} {el.apellido2}</td>
                                            <td>{el.fecha_registro}</td>
                                            <td>{el.institucion_educativa}</td>
                                            <td>{el.titulo}</td>
                                            <td>{el.correo_electronico}</td>
                                            <td>{el.telefono}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        ):(
                            <MessageDetail mensaje="No se encontraron solicitudes asignadas"/>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Record;